import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ModuleCard = ({ module, onActivate, onConfigure, onAccess, userRole }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
      case 'available':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
      case 'inactive':
        return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400';
    }
  };

  const canActivate = userRole === 'Safety Manager' || userRole === 'Compliance Officer';
  const canConfigure = userRole === 'Safety Manager' || userRole === 'Compliance Officer';

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-300 flex flex-col h-full">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
            module.status === 'active' ? 'bg-primary/10' : 'bg-muted'
          }`}>
            <Icon name={module.icon} size={24} color={module.status === 'active' ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{module.name}</h3>
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(module.status)}`}>
              {module.status?.charAt(0)?.toUpperCase() + module.status?.slice(1)}
            </span>
          </div>
        </div>
        {module.isPrimary && (
          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-accent/10 text-accent">
            Primary
          </span>
        )}
      </div>
      <p className="text-sm text-muted-foreground mb-4 flex-grow">{module.description}</p>
      <div className="space-y-3 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Locations:</span>
          <span className="font-medium text-foreground">{module.locations}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Last Updated:</span>
          <span className="font-medium text-foreground">{module.lastUpdated}</span>
        </div>
      </div>
      <div className="flex gap-2 mt-4">
        {module.status === 'active' ? (
          <>
            <Button
              variant="default"
              size="sm"
              fullWidth
              iconName="ExternalLink"
              iconPosition="right"
              onClick={() => onAccess(module)}
            >
              Access Module
            </Button>
            {canConfigure && (
              <Button
                variant="outline"
                size="sm"
                iconName="Settings"
                onClick={() => onConfigure(module)}
              />
            )}
          </>
        ) : module.status === 'available' ? (
          <>
            {canActivate && (
              <Button
                variant="default"
                size="sm"
                fullWidth
                iconName="Plus"
                iconPosition="left"
                onClick={() => onActivate(module)}
              >
                Activate Module
              </Button>
            )}
          </>
        ) : (
          <Button variant="outline" size="sm" fullWidth disabled>
            Coming Soon
          </Button>
        )}
      </div>
    </div>
  );
};

export default ModuleCard;